import {exhaustivenessCheck} from 'nutshell-core/typing/exhaustiveness-check';

import {FormRegularCheckIcon, LeadChevronRegularIcon, PersonSearchRegularAiIcon} from 'shells/icon';

import {BoxRegularIcon} from '../icon/svg/box-regular-icon';
import {BusinessCardRegularIcon} from '../icon/svg/business-card-regular-icon';
import {CalendarRegularPenIcon} from '../icon/svg/calendar-regular-pen-icon';
import {CalendarSquareRegularActivityIcon} from '../icon/svg/calendar-square-regular-activity-icon';
import {ChatBubbleDoubleRegularIcon} from '../icon/svg/chat-bubble-double-regular-icon';
import {ChatRegularIcon} from '../icon/svg/chat-regular-icon';
import {CompanyRegularIcon} from '../icon/svg/company-regular-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CompetitorRegularIcon} from '../icon/svg/competitor-regular-icon';
import {EnvelopeNewIcon} from '../icon/svg/envelope-new-icon';
import {EnvelopesRegularIcon} from '../icon/svg/envelopes-regular-icon';
import {HierarchyRegularIcon} from '../icon/svg/hierarchy-regular-icon';
// @ts-expect-error - imported from .js/.jsx file
import {HtmlAttachmentIcon} from '../icon/svg/html-attachment-icon';
import {InfoSquareIcon} from '../icon/svg/info-square-icon';
import {LeadResearcherIcon} from '../icon/svg/lead-researcher-icon';
// @ts-expect-error - imported from .js/.jsx file
import {NewTimelineIcon} from '../icon/svg/new-timeline-icon';
// @ts-expect-error - imported from .js/.jsx file
import {PeepsBookIcon} from '../icon/svg/peeps-book';
// @ts-expect-error - imported from .js/.jsx file
import {PencilToPaperIcon} from '../icon/svg/pencil-to-paper-icon';
import {PeopleRegularIcon} from '../icon/svg/people-regular-icon';
import {PersonRoundRegularIcon} from '../icon/svg/person-round-regular-icon';
import {PhoneOutlineIcon} from '../icon/svg/phone-outline-icon';
import {QuoteRegularIcon} from '../icon/svg/quote-regular-icon';
import {SourcesIcon} from '../icon/svg/sources-icon';
import {TagRegularDiagonalIcon} from '../icon/svg/tag-regular-diagonal-icon';
import {TaskTickOutlineIcon} from '../icon/svg/task-tick-outline';
import {TextRegularAiIcon} from '../icon/svg/text-regular-ai-icon';
import {TimelineRegularIcon} from '../icon/svg/timeline-regular-icon';
import {LoadingPage} from '../loading-page/loading-page';
import {LoadingText} from '../loading-placeholder/loading-text';

import type {RealAndFakeWidgetType} from './types';

export const getWidgetIconForType = (widgetType?: RealAndFakeWidgetType | null) => {
    if (!widgetType) {
        return undefined;
    }

    switch (widgetType) {
        case 'CUSTOM_CUSTOM_FIELDS':
        case 'ALL_CUSTOM_FIELDS':
            return PencilToPaperIcon;
        case 'COMPANIES_AND_PEOPLE':
            return PeepsBookIcon;
        case 'AUTOMATED_EMAILS':
            return EnvelopesRegularIcon;
        case 'TASKS':
            return TaskTickOutlineIcon;
        case 'ACTIVITIES':
            return CalendarSquareRegularActivityIcon;
        case 'TIMELINE':
            return NewTimelineIcon;
        case 'COMPETITORS':
            return CompetitorRegularIcon;
        case 'SOURCES':
            return SourcesIcon;
        case 'REVENUE':
            if (NutClientConfig.hasRevenueWidgetFF) {
                return TagRegularDiagonalIcon;
            } else {
                return BoxRegularIcon;
            }
        case 'ATTACHMENTS':
            return HtmlAttachmentIcon;
        case 'SALES_PROCESS':
            return TimelineRegularIcon;
        case 'CHAT':
            return ChatBubbleDoubleRegularIcon;
        case 'BOOK':
            return CalendarRegularPenIcon;
        case 'EMAIL':
            return EnvelopeNewIcon;
        case 'CALL':
            return PhoneOutlineIcon;
        case 'TEXT':
            return ChatRegularIcon;
        case 'QUOTE':
            return QuoteRegularIcon;
        case 'AI_SUMMARY':
            return TextRegularAiIcon;
        case 'LEAD_RESEARCHER':
            return LeadResearcherIcon;
        case 'RELATED_CONTACTS':
            return PersonRoundRegularIcon;
        case 'RELATED_ACCOUNTS':
            return CompanyRegularIcon;
        case 'BUSINESS_CARD':
            return BusinessCardRegularIcon;
        case 'LEADS':
            return LeadChevronRegularIcon;
        case 'CHILD_LEADS':
            return LeadChevronRegularIcon;
        case 'COMPANY_HIERARCHY':
            return HierarchyRegularIcon;
        case 'AUDIENCES':
            return PeopleRegularIcon;
        case 'EMAIL_ENGAGEMENT':
            return EnvelopeNewIcon;
        case 'FORMS':
            return FormRegularCheckIcon;
        case 'NUTSHELL_IQ':
            return PersonSearchRegularAiIcon;
        case 'SUMMARY':
            return InfoSquareIcon;
        default:
            exhaustivenessCheck(widgetType);
    }
};

export const getIsLockedWidget = (type?: RealAndFakeWidgetType | null) => {
    if (!type) {
        return false;
    }

    switch (type) {
        case 'TIMELINE':
            return true;
        default:
            return false;
    }
};

export const getLoadingComponent = (type?: RealAndFakeWidgetType | null) => {
    switch (type) {
        case 'AI_SUMMARY':
            return <LoadingText color='#E3D8FD' isAnimated={true} isFullWidth={true} />;
        case 'LEAD_RESEARCHER':
            return (
                <div className='flex full-width flex-dir-col gap-8 px-12 py-8'>
                    <LoadingText color='#E3D8FD' isAnimated={true} isFullWidth={true} />
                    <LoadingText color='#E3D8FD' isAnimated={true} isFullWidth={true} />
                    <LoadingText color='#E3D8FD' isAnimated={true} isFullWidth={true} />
                </div>
            );
        default:
            return <LoadingPage padding={16} />;
    }
};
